import { render, staticRenderFns } from "./PurchasesTableCustomFilterBtn.vue?vue&type=template&id=46b54194&scoped=true"
import script from "./PurchasesTableCustomFilterBtn.vue?vue&type=script&lang=js"
export * from "./PurchasesTableCustomFilterBtn.vue?vue&type=script&lang=js"
import style0 from "./PurchasesTableCustomFilterBtn.vue?vue&type=style&index=0&id=46b54194&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b54194",
  null
  
)

export default component.exports